
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', () => drawer.classList.toggle('is-open'));
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.faq-q');
    if(btn) btn.addEventListener('click', () => item.classList.toggle('is-open'));
  });

  document.querySelectorAll('[data-accordion]').forEach(item => {
    const btn = item.querySelector('.accordion-btn');
    if(btn) btn.addEventListener('click', () => item.classList.toggle('is-open'));
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const form = select.closest('form');
    if(!form) return;
    select.addEventListener('change', () => {
      const optionValues = Array.from(form.querySelectorAll('[data-variant-select]')).map(s => s.value);
      const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
      const match = variants.find(v => JSON.stringify(v.options) === JSON.stringify(optionValues));
      if(match){
        const idInput = form.querySelector('[name="id"]');
        if(idInput) idInput.value = match.id;
        const price = form.closest('.product-info')?.querySelector('[data-product-price]');
        if(price && match.price_formatted) price.textContent = match.price_formatted;
        const add = form.querySelector('[data-add-button]');
        if(add){
          add.disabled = !match.available;
          add.textContent = match.available ? 'Añadir al carrito' : 'Agotado';
        }
      }
    });
  });
});
